<!--  -->
<template>
  <div class="page" :class="{ active: isApp || miniprogram }">
    <common-title v-if="!isApp && !miniprogram" titleName="课程体验" :zIndex="1000"></common-title>
    <div class="main">
      <h1 class="title">课程试听</h1>
      <div class="cover" @click="toLearn">
        <img class="img" :src="courseDetail.coverMobile" alt="" />
        <img
          class="audition"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/vipProduct/icon9.png"
        />
      </div>
    </div>
    <div class="server">
      <h1 class="title">学习服务</h1>
      <div class="box">
        <div class="item" v-for="(item, k) in learnServiceList" :key="k" @click="toServer(k)">
          <img :src="item.icon" />
          <p>{{ item.title }}</p>
        </div>
      </div>
    </div>
    <div class="recommend">
      <h1 class="title">推荐课程</h1>
      <div>
        <CourseCard v-for="(item, i) in courseList" :key="i" :item="item" />
      </div>
    </div>
    <div class="chat" @click="openChat"></div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { reqCourseExperience } from '@/api/vipProduct/index';
import { reqIsBuyProduct, reqCourseDetail } from '@/api/courseDetail/index';
import { reqProducts, reqTypeList } from '@/api/home';
import { resetProductData } from '@/utils/tools';
import { getTaskApi } from '@/api/member/index';
import CourseCard from './components/courseCard.vue';

export default {
  components: {
    CourseCard,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      experienceProductId: '',
      learnServiceList: [],
      courseDetail: {},
      buyInfo: [],
      courseList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 查权益
    async getVipCourse() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { id } = this.$route.query;
      const { data } = await reqCourseExperience(id);
      const { vipCourseExperienceConfigRespVO } = data;
      const { experienceProductId, customServicesList, learnService, reProductList } =
        vipCourseExperienceConfigRespVO;
      const serviceList = learnService.split(',');
      this.experienceProductId = experienceProductId;
      await this.getCourseSku(experienceProductId);
      this.checkCourse(experienceProductId);
      this.getCourseList(reProductList);
      await this.getDictionary(serviceList, customServicesList);
      this.$toast.clear();
    },
    // 查课程sku
    async getCourseSku(id) {
      const { data } = await reqCourseDetail(id);
      this.courseDetail = data;
    },
    // 查开课状态
    async checkCourse(id) {
      const { data } = await reqIsBuyProduct(id);
      this.buyInfo = data || [];
    },
    // 查课程列表
    async getCourseList(ids) {
      const endPoint = this.isApp ? 2 : 4;
      const { data } = await reqProducts(ids, endPoint);
      const resCourse = resetProductData(data || []);
      this.courseList = resCourse;
    },
    // 查基础字段
    async getDictionary(serviceList, customServicesList) {
      const { data } = await reqTypeList('VIP_SERVICES');
      const learnServiceArr = data
        .filter((item) => serviceList.some((subItem) => item.code === subItem))
        .map((item) => {
          const { remark, value, code } = item;
          const { title, icon } = JSON.parse(remark);
          return {
            title,
            icon,
            content: value,
            code,
          };
        });
      this.learnServiceList = [...learnServiceArr, ...customServicesList];
    },
    // 去试听
    async toLearn() {
      if (!this.buyInfo?.length) {
        this.$toast('未开通课程');
        return;
      }
      const { id } = this.buyInfo?.[0];
      const res = await this.entranceTask(id);
      if (res === 'unFinished') {
        if (this.miniprogram) {
          this.$toast('请前往app完成入学任务后，即可查看课程视频');
        } else if (this.isApp) {
          const { origin } = window.location;
          const url = `${origin}/ark/entranceTask?id=${id}`;
          this.$sendToApp('openNewWebView', { url }, false);
        } else {
          this.$router.push({
            path: '/entranceTask',
            query: {
              id,
            },
          });
        }
      } else if (res === 'finished') {
        if (this.$root.miniprogram) {
          wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
        } else if (this.$root.$data.isApp) {
          this.$sendToApp('goDirectoryPage', { courseId: id }, false);
        } else {
          this.$router.push({
            path: '/learningGuide',
            query: {
              catalogId: id,
            },
          });
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const { agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone } =
          data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) ||
          (examId && !examDone) ||
          (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    async goGuide(productId) {
      const info = await reqIsBuyProduct(productId);
      if (info.code === 0 && info?.data?.length) {
      } else {
        this.$toast('未开通课程');
      }
    },
    // asd
    toServer(i) {
      const { id } = this.$route.query;
      this.$router.push({
        path: '/vipExperience',
        query: {
          active: i,
          id,
        },
      });
    },
    openChat() {
      let url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=665818671c64a1000119f4b2';
      if (this.$root.$data.isApp) {
        url =
          'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66696197735feb0001e5a925';
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
  },
  created() {},
  mounted() {
    document.title = '课程体验';
    this.getVipCourse();
  },
};
</script>
<style lang="scss" scoped>
.page.active {
  padding-top: 22px;
}
.page {
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: 122px;
  background: #f7f8fc;
  .title {
    padding-bottom: 22px;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }
  .main {
    width: 678px;
    margin: 0 auto 22px;
    padding: 29px;
    background: #fff;
    border-radius: 14px;

    .cover {
      position: relative;
      .img {
        width: 620px;
        height: 447px;
        border-radius: 14px;
      }
      .audition {
        position: absolute;
        right: 29px;
        bottom: 29px;
        width: 210px;
        height: 65px;
      }
    }
  }
  .server {
    width: 678px;
    margin: 0 auto;
    padding: 29px;
    background: #fff;
    border-radius: 14px;
    .box {
      display: flex;
      flex-wrap: wrap;
      padding-top: 29px;
      .item:nth-child(5n) {
        margin-right: 0;
      }
      .item {
        width: 120px;
        margin: 0 5px 22px 0;
        img {
          display: block;
          width: 72px;
          height: 72px;
          margin: 0 auto;
        }
        p {
          padding-top: 11px;
          color: #333;
          font-weight: 400;
          font-size: 22px;
          text-align: center;
        }
      }
    }
  }
  .recommend {
    width: 678px;
    margin: 22px auto;
    padding: 29px;
    background: #fff;
    border-radius: 14px;
  }
  .chat {
    position: fixed;
    right: 0;
    bottom: 300px;
    width: 127px;
    height: 105px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/vipProduct/chat-icon2.png');
    background-size: 100%;
  }
}
</style>
